import React, { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import useApi from '../../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField from '../../../../../utils/InputField';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function ModalUpdateQuotationNumber() {
    const { handleReload, invoiceInfo } = useInvoiceInfo();
    const { put } = useApi();
    const { setMessage, closeModal } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const data = invoiceInfo?.invoice || {};
    const [formData, setFormData] = useState({
        Id: data?.id,
        QuotationNo: data?.quotationNo || ''
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        setLoading(true);
        put(`/api/invoices/${data?.id}/update-quotation-number`, formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                closeModal();
                handleReload();
                setMessage({ type: 'success', text: message });
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleSaveClick}>
            <div className="flex flex-col gap-y-3 mb-5">
                <InputField
                    label="Quotation No."
                    name="QuotationNo"
                    placeholder="Type Quotation No..."
                    formData={formData}
                    onChange={handleChange}
                    required
                />

                {/* Add label, Quotation No. must be unique */}
                <p className="text-sm text-gray-500">Quotation No. must be unique.</p>
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Update" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ModalUpdateQuotationNumber;
